/* eslint-disable no-invalid-this */

/**
 * Refreshes tokens using the Habile flow.
 *
 * For Habile, the authToken (Habile's equivalent for the Cognito token) must be provided.
 * This function directly calls fetchNeonApiTokenAndUser with the authToken.
 *
 * @param {string} [organisationTenantSlug=''] - Organisation slug for multi-tenancy.
 * @param {number} attemptsCount - Number of refresh attempts so far.
 * @param {string} [authToken=''] - The Habile auth token.
 * @returns {Promise<Object>} - Resolves with the authenticated user object.
 */
export function refreshTokens(organisationTenantSlug = '', attemptsCount, authToken = '') {
    if (!authToken) {
        return Promise.reject(new Error('No auth token provided for Habile refresh.'));
    }
    return this.fetchNeonApiTokenAndUser(authToken, '', organisationTenantSlug, attemptsCount)
        .then(user => {
            this.logger.notice({
                message: 'Neon-api Refresh token exchange successful (Habile)',
                userUuid: user.uuid,
                component: 'neonAuth'
            });
            return user;
        })
        .catch(error => {
            this.logger.error({
                message: 'Unsuccessful refresh token exchange from neon-api (Habile)',
                error,
                component: 'neonAuth'
            });
            return Promise.reject(error);
        });
}
